import { Facebook, Instagram, LinkedIn, WhatsApp, YouTube } from '@mui/icons-material';


let projectBaseUrl = "https://raw.githubusercontent.com/Azitech-global/jb-architects-engineers-images/refs/heads/main/website/Projects/"
let blogBaseUrl = "https://raw.githubusercontent.com/Azitech-global/jb-architects-engineers-images/refs/heads/main/images/blog/"
let serviceBaseUrl = "https://raw.githubusercontent.com/Azitech-global/jb-architects-engineers-images/refs/heads/main/images/Service/"

export const socialMedia = [
    // {
    //   icon: <WhatsAppIcon fontSize="small" color="#25D366" />,
    //   backgroundColor: "#25D366",
    //   title: "Whatsapp",
    //   info: "+91-8056707579",
    // },
    {
        icon: {
            small: <Facebook fontSize="small" color="#3b5998" />,
            medium: <Facebook fontSize="medium" color="#3b5998" />,
            large: <Facebook fontSize="large" color="#3b5998" />,
        },
        backgroundColor: "#3b5998",
        title: "Facebook",
        info: "https://m.facebook.com/jbarchitectsandengineers/",
    },

    {
        icon: {
            small: <Instagram fontSize="small" color="#E4405F" />,
            medium: <Instagram fontSize="medium" color="#E4405F" />,
            large: <Instagram fontSize="large" color="#E4405F" />,
        },
        backgroundColor: "#E4405F",
        title: "Instagram",
        info: "https://instagram.com/jb_architects_and_engineers?igshid=ZDdkNTZiNTM=",
    },

    {
        icon: {
            small: <LinkedIn fontSize="small" color="#0077B5" />,
            medium: <LinkedIn fontSize="medium" color="#0077B5" />,
            large: <LinkedIn fontSize="large" color="#0077B5" />,
        },
        backgroundColor: "#0077B5",
        title: "Linkedin",
        info: "https://www.linkedin.com/posts/mohamed-hassim-7a384710a_architects-sustainabledesign-jbarchitectsandengineers-activity-7276237967415762944-Mg3N?utm_source=share&utm_medium=member_android",
    },
    {
        icon: {
            small: <YouTube fontSize="small" color="#FF0000" />,
            medium: <YouTube fontSize="medium" color="#FF0000" />,
            large: <YouTube fontSize="large" color="#FF0000" />,
        },
        backgroundColor: "#FF0000",
        title: "Youtube",
        info: "https://youtube.com/@jbarchitectsengineers",
    },
    {
        icon: {
            small: <WhatsApp fontSize="small" color="#128C7E" />,
            medium: <WhatsApp fontSize="medium" color="#128C7E" />,
            large: <WhatsApp fontSize="large" color="#128C7E" />,
        },
        backgroundColor: "#128C7E",
        title: "WhatsApp",
        info: "https://wa.me/qr/RYGE52O4WS24I1",
    },
];
export const googleReviews = [
    {
        id: 1,
        name: "FAIZAL KANI",
        image: "https://via.placeholder.com/150",
        review: `I recently had the pleasure of working with Hasim  to design the ground floor plans for my new building, and I am beyond impressed with the results. From the first consultation to the final drafts, he was highly professional, attentive, and incredibly detail-oriented.\n
                He took the time to understand my needs and preferences, offering valuable insights and creative suggestions that truly enhanced the overall design. The layout they provided was not only functional and efficient but also aesthetically pleasing, maximizing the use of space while maintaining a great flow between rooms.The entire process was smooth, and they were always available to address any questions or concerns I had along the way. Their expertise really shines through in their work, and I couldn’t be happier with how the plans turned out.
                If you’re looking for a company that delivers excellent ground floor plans with a focus on quality and customer satisfaction, I highly recommend JB Architects . I look forward to working with them on future projects!`,
        star: 5
    },
    {
        id: 2,
        name: "Murugesan R",
        image: "https://via.placeholder.com/150",
        review: "Very good design work and quality construction.. Would love to refer the builder to friends and family. It would be really nice if you could complete the construction little faster. Very nice technical team you have.",
        star: 4
    },
    {
        id: 3,
        name: "Jabir Rizwan",
        image: "https://via.placeholder.com/150",
        review: "Thank you so much Thoufiq and Hashim for building our dream home. Experience was wonderful and it will be cherished forever Insha allah. Feel free to reach us if you need to show the house as reference. Thanks again for all your support.",
        star: 5
    },
    {
        id: 4,
        name: "Shahul Hameed",
        image: "https://via.placeholder.com/150",
        review: "JB architect did My home renovation. First of all thanks.. for.. made my home better then before. Source of good construction is best plan and ideas.... They came to me with a best plan for my home renovation. They provide a plan according to my requirement. Thanks again... Best of luck... Iooking for future projects with you...",
        star: 5
    },
    {
        id: 5,
        name: "vadivel prabu",
        image: "https://via.placeholder.com/150",
        review: "Dedicated designer and communicate with you well..",
        star: 5
    },
    {
        id: 6,
        name: "khaja mohideen",
        image: "https://via.placeholder.com/150",
        review: "VERY GOOD ENGINERS.ALWAYS BETTER SERVICE.ALHAMDHULILLAH , JAZAKALLAH KAIR",
        star: 5
    },
];


export const postData = [
    {
        id: 1,
        title: "Elegant Home Interior Design",
        time: '',
        post: '🏡 Beautiful Interior by J B Architects and Engineer',
        pointDetails: {
            pointsTitle: ' ',
            customMarker: "✨",
            points: [
                "Double-height ceilings",
                "Modern lighting and glass railings",
                "Nature-inspired elements"
            ],
        },
        description: `DM us for your dream home design!`,
        image: blogBaseUrl+'blog5.jpg',
        thumbnail: 'image',
        videoLink: false,
        isUrl: false

    },
    {
        id: 2,
        title: "Modern Elegance: A Stunning Home Design",
        time: '',
        post: 'Hi there! 👋 Here’s one of our beautiful home designs by JB Architects & Engineers.',
        pointDetails: {
            pointsTitle: '🏡 Design Highlights:',
            customMarker: "✨",
            points: [
                "Sleek and modern architecture",
                "Neutral and timeless color palette",
                "Bright, open spaces"
            ],
        },
        description: `Thinking of designing your dream home? We’d love to help!`,
        image: blogBaseUrl+'blog4.jpg',
        thumbnail: 'image',
        htmlContent: false,


    },
    {
        id: 3,
        title: "Transforming Visions into Reality 🏡✨",
        time: '',
        post: 'Here’s a glimpse of one of our ongoing projects at J B Architects & Engineers. From initial concept to final structure, every step reflects our commitment to innovative and sustainable design.',
        pointDetails: {
            pointsTitle: '📌 Services We Offer:',
            customMarker: " ",
            points: [
                "Architectural Planning & Drawings",
                "Interior & Exterior Design",
                "Construction Consultancy"
            ],
        },
        description: `Stay tuned for more updates, and let us help you build your dream home! 💡`,
        image: blogBaseUrl+'blog3.jpg',
        thumbnail: 'image',
        htmlContent: false,
    },
    {
        id: 4,
        title: "J B Architects & Engineers",
        time: '',
        post: 'Integrated Architectural Solutions: Concept-to-Completion Planning, Design, Drawings, Interiors, Exteriors, and Construction Consulting.',
        pointDetails: {
            pointsTitle: '',
            customMarker: "✨",
            points: [],
        },
        description: `Thinking of designing your dream home? We’d love to help!`,
        image: blogBaseUrl+'blog2.jpg',
        thumbnail: 'image',
        htmlContent: false,
    },
    {
        id: 5,
        title: "Furniture showroom exterior design  ",
        time: '',
        post: 'To learn more about your dream home construction follow us. If u have any queries feel free to contact us.',
        pointDetails: {
            pointsTitle: '',
            customMarker: "✨",
            points: [],
        },
        description: `Thinking of designing your dream home? We’d love to help!`,
        image: blogBaseUrl+'blog1.jpg',
        thumbnail: 'image',
        htmlContent: false,
    },
    {
        id: 6,
        title: "Clinic Interior design done ",
        time: '',
        post: 'To learn more about your dream home construction follow us. If u have any queries feel free to contact us.',
        pointDetails: {
            pointsTitle: '',
            customMarker: "✨",
            points: [],
        },
        description: `Thinking of designing your dream home? We’d love to help!`,
        image: blogBaseUrl+'blog6.jpg',
        thumbnail: 'image',
        htmlContent: false,
    },
    {
        id: 7,
        title: "Staircase Construction in 7 feet by 8 feet Room in old building renovation",
        time: '',
        post: 'In small space we achieved proper Staircase with 7 inch Riser and 10 inch tread Our customer is satisfied with staircase',
        pointDetails: {
            pointsTitle: ' ',
            customMarker: "✨",
            points: [],
        },
        description: `To learn more about your dream home construction follow us. If u have any queries feel free to contact us.`,
        image: blogBaseUrl+'blog5.jpg',
        thumbnail: 'video',
        isVideoLink: true,
        urls: {
            faceBook: '',
            YouTube: 'https://youtube.com/shorts/JgX56HuwI44?si=035v98Elf7wLPgzi'
        }
    },
    {
        id: 8,
        title: "Residence project from design to execution completed",
        time: '',
        post: '',
        pointDetails: {
            pointsTitle: ' ',
            customMarker: "✨",
            points: [],
        },
        description: `To learn more about your dream home construction follow us. If u have any queries feel free to contact us.`,
        image: blogBaseUrl+'blog5.jpg',
        thumbnail: 'video',
        isVideoLink: true,
        urls: {
            faceBook: '',
            YouTube: 'https://youtube.com/shorts/9XCEAmRPTsI?si=NJZbXUzM2KZ3AKeK'
        }
    },
    {
        id: 9,
        title: "Residence project from 3D design to execution completed",
        time: '',
        post: '',
        pointDetails: {
            pointsTitle: ' ',
            customMarker: "✨",
            points: [],
        },
        description: `To learn more about your dream home construction follow us. If u have any queries feel free to contact us.`,
        image: blogBaseUrl+'blog5.jpg',
        thumbnail: 'video',
        isVideoLink: true,
        urls: {
            faceBook: '',
            YouTube: 'https://youtube.com/shorts/REkEpKYrFBo?si=gtQ5YxlSNTY7d4qg'
        }
    },
    {
        id: 10,
        title: "Modern Living Room – Where Style Meets Comfort! ✨",
        time: '',
        post: 'Upgrade your home with a sleek, stylish, and inviting living space! Designed for both elegance and relaxation, this interior features:',
        pointDetails: {
            pointsTitle: ' ',
            customMarker: "✔",
            points: [
                'Elegant ceiling design with decorative panels & warm lighting',
                'Chic pendant lights for a cozy ambiance',
                'Wall-mounted aquarium for a unique and calming touch',
                'Floating TV unit with open shelves for a clean, modern look',
                'Neutral-toned furniture for a balanced and sophisticated feel',
                'Glossy marble flooring & sheer curtains to enhance luxury'
            ],
        },
        description: `To learn more about your dream home construction follow us. If u have any queries feel free to contact us.`,
        image: blogBaseUrl+'blog7.jpg',
        thumbnail: 'image',
        isVideoLink: true,
        urls: {
            faceBook: '',
            YouTube: ''
        }
    },

]

export const projectList = [
    {
        name: "Aleen nagar residence",
        image: [{
            itemImageSrc: projectBaseUrl + 'Architecture/Aleen nagar residence/11 Exterior Design.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Aleen nagar residence/11 Exterior Design.jpg',
            alt: 'jb architects and engineers',
            title: 'Exterior Design'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Aleen nagar residence/Bedroom Design.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Aleen nagar residence/Bedroom Design.jpg',
            alt: 'architects in tirunelveli',
            title: 'Bedroom Design'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Aleen nagar residence/Bedroom layout.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Aleen nagar residence/Bedroom layout.jpg',
            alt: 'top architects consultant in tirunelveli',
            title: 'Bedroom Layout'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Aleen nagar residence/Design to real.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Aleen nagar residence/Design to real.jpg',
            alt: 'best architects in tirunelveli',
            title: 'Design to real'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Aleen nagar residence/DRESSING room.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Aleen nagar residence/DRESSING room.jpg',
            alt: 'engineering firms in tirunelveli',
            title: 'DRESSING room'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Aleen nagar residence/Elevation photo.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Aleen nagar residence/Elevation photo.jpg',
            alt: 'jb architects and engineers tirunelveli',
            title: 'Elevation'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Aleen nagar residence/Hall interior.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Aleen nagar residence/Hall interior.jpg',
            alt: 'best architects for your dream home',
            title: 'Hall interior'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Aleen nagar residence/openning shaft.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Aleen nagar residence/openning shaft.jpg',
            alt: 'Interior Designers',
            title: 'Openning Shaft'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Aleen nagar residence/Staircase Handrail design.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Aleen nagar residence/Staircase Handrail design.jpg',
            alt: 'home renovation',
            title: 'Staircase Handrail design'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Aleen nagar residence/staircase section.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Aleen nagar residence/staircase section.jpg',
            alt: 'best interior designers',
            title: 'staircase section'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Aleen nagar residence/Toilet design.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Aleen nagar residence/Toilet design.jpg',
            alt: 'Residential Interior Design',
            title: 'Toilet design'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Aleen nagar residence/staircase drawing.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Aleen nagar residence/staircase drawing.jpg',
            alt: 'commercial interior design',
            title: 'staircase drawing'
        },
        ],
        description: "test description fsdfsdf sdf dsf dsf sd fds f dsf sdfsdfsdf sdf sd fs dfds fsd f dsf ds fsd fs df sf",
        type: "architecture",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Er Ravi",
        image: [{
            itemImageSrc: projectBaseUrl + 'Architecture/Er Ravi/11 Clasic Residence Design.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Er Ravi/11 Clasic Residence Design.jpg',
            alt: 'Modern Interior Design',
            title: 'Clasic Residence Design'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Er Ravi/12 ground floor plan.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Er Ravi/12 ground floor plan.jpg',
            alt: 'Affordable architects',
            title: 'Ground floor plan'
        },

        ],
        description: "test description fsdfsdf sdf dsf dsf sd fds f dsf sdfsdfsdf sdf sd fs dfds fsd f dsf ds fsd fs df sf",
        type: "architecture",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Fazil Residence",
        image: [{
            itemImageSrc: projectBaseUrl + 'Architecture/Fazil mpm residence/11 Residence Exterior.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Fazil mpm residence/11 Residence Exterior.jpg',
            alt: 'exterior architectural design',
            title: 'Exterior Design'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Fazil mpm residence/12 Residence PLAN.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Fazil mpm residence/12 Residence PLAN.jpg',
            alt: 'top architecture firms in tirunelveli',
            title: 'Residence PLAN'
        },
        {
 itemImageSrc: projectBaseUrl + 'Architecture/Fazil mpm residence/13 Plung drawing.jpg',
         thumbnailImageSrc: projectBaseUrl + 'Architecture/Fazil mpm reence/13 Plumbing drawing.jpg',
            alt: 'tirunelveli architectural services',
            title: 'Plumbing drawing'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Fazil mpm residence/14 residence electrical drawing.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Fazil mpm residence/14 residence electrical drawing.jpg',
            alt: 'residence electrical drawing',
            title: 'Residence electrical drawing'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Fazil mpm residence/15 Residence exterior photo.JPG',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Fazil mpm residence/15 Residence exterior photo.JPG',
            alt: 'affordable architectural design for homes',
            title: 'Residence exterior'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Fazil mpm residence/16 Elevation Photo.JPG',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Fazil mpm residence/16 Elevation Photo.JPG',
            alt: 'modern house designs by architects',
            title: 'Elevation'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Fazil mpm residence/17 Entrance photo.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Fazil mpm residence/17 Entrance photo.jpg',
            alt: 'architecture and engineering firm near me',
            title: 'Entrance'
        },

        ],
        description: "test description fsdfsdf sdf dsf dsf sd fds f dsf sdfsdfsdf sdf sd fs dfds fsd f dsf ds fsd fs df sf",
        type: "architecture",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Habibullah Residence",
        image: [{
            itemImageSrc: projectBaseUrl + 'Architecture/Habibullah Residence/11 Ground floor exterior design.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Habibullah Residence/11 Ground floor exterior design.jpg',
            alt: 'home exterior design',
            title: 'Ground floor exterior design'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Habibullah Residence/12 Ground floor plan.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Habibullah Residence/12 Ground floor plan.jpg',
            alt: 'residential exterior design',
            title: 'Ground floor plan'
        },
        {
 itemImageSrc: projectBaseUrl + 'Architecture/Habibullah Residence/13 First floor plan.jpg',
         thumbnailImageSrc: projectBaseUrl + 'Architecture/Habibullah Residence/13 First floor plan.jpg',
            alt: 'exterior architectural design',
            title: 'First floor plan'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Habibullah Residence/14 Elevation drawing.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Habibullah Residence/14 Elevation drawing.jpg',
            alt: 'commercial exterior design',
            title: 'Elevation drawing'
        },

        ],
        description: "test description fsdfsdf sdf dsf dsf sd fds f dsf sdfsdfsdf sdf sd fs dfds fsd f dsf ds fsd fs df sf",
        type: "architecture",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Hithayathullah Residency",
        image: [{
            itemImageSrc: projectBaseUrl + 'Architecture/Hithayathullah/11 Grand residence exterior.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Hithayathullah/11 Grand residence exterior.jpg',
            alt: '1Grand residence exterior',
            title: 'Grand residence exterior'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Hithayathullah/12 Ground floor CP.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Hithayathullah/12 Ground floor CP.jpg',
            alt: 'house front elevation design',
            title: 'Ground floor CP'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Hithayathullah/13 First floor CP.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Hithayathullah/13 First floor CP.jpg',
            alt: '3D exterior design',
            title: 'First floor CP'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Hithayathullah/14 Ground floor WD.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Hithayathullah/14 Ground floor WD.jpg',
            alt: 'Ground floor WD',
            title: 'Ground floor WD'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Hithayathullah/15 First floor WD.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Hithayathullah/15 First floor WD.jpg',
            alt: 'building exterior design',
            title: 'First floor WD'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Hithayathullah/16 Staircase Drawing.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Hithayathullah/16 Staircase Drawing.jpg',
            alt: 'exterior designers in Tirunelveli',
            title: 'Staircase Drawing'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Hithayathullah/17 GF Electrical drawing.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Hithayathullah/17 GF Electrical drawing.jpg',
            alt: 'modern house exterior design Tirunelveli',
            title: 'GF Electrical drawing'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Hithayathullah/18 Elevation drawing.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Hithayathullah/18 Elevation drawing.jpg',
            alt: 'Tirunelveli exterior design company',
            title: 'Elevation drawing'
        },

        ],
        description: "test description fsdfsdf sdf dsf dsf sd fds f dsf sdfsdfsdf sdf sd fs dfds fsd f dsf ds fsd fs df sf",
        type: "architecture",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name:"Imbran Residence",
        image: [{
            itemImageSrc: projectBaseUrl+'Architecture/Imbran Residence/11 Residence Design.jpg',
            thumbnailImageSrc: projectBaseUrl+'Architecture/Imbran Residence/11 Residence Design.jpg',
            alt: 'front elevation designers in Tirunelveli',
            title: 'Residence Design'
        },
        {
            itemImageSrc: projectBaseUrl+'Architecture/Imbran Residence/12 Ground floor plan.jpg',
            thumbnailImageSrc: projectBaseUrl+'Architecture/Imbran Residence/12 Ground floor plan.jpg',
            alt: 'top exterior architects near me',
            title: 'Ground floor plan'
        },
    
    ],
        description:"test description fsdfsdf sdf dsf dsf sd fds f dsf sdfsdfsdf sdf sd fs dfds fsd f dsf ds fsd fs df sf",
        type:"architecture",
        duration:"2",
        purpose:"residential",
        client:"Aleen nagar"
    },
    {
        name:"Jabir Residence",
        image: [{
            itemImageSrc: projectBaseUrl+'Architecture/Jabir Residence/11 Residence Exterior design.jpg',
            thumbnailImageSrc: projectBaseUrl+'Architecture/Jabir Residence/11 Residence Exterior design.jpg',
            alt: 'home exterior design Tirunelveli',
            title: '11 Residence Exterior design'
        },
        {
            itemImageSrc: projectBaseUrl+'Architecture/Jabir Residence/12 Residence exterior photo.jpg',
            thumbnailImageSrc: projectBaseUrl+'Architecture/Jabir Residence/12 Residence exterior photo.jpg',
            alt: 'home exterior design Tirunelveli',
            title: 'Residence exterior'
        },
        {
            itemImageSrc: projectBaseUrl+'Architecture/Jabir Residence/13 Ground floor plan FN.jpg',
            thumbnailImageSrc: projectBaseUrl+'Architecture/Jabir Residence/13 Ground floor plan FN.jpg',
            alt: 'affordable exterior design for small homes',
            title: 'Ground floor plan FN'
        },
        {
            itemImageSrc: projectBaseUrl+'Architecture/Jabir Residence/14 First floor Render.jpg',
            thumbnailImageSrc: projectBaseUrl+'Architecture/Jabir Residence/14 First floor Render.jpg',
            alt: 'modern front elevation ideas for Indian homes',
            title: 'First floor Render'
        },
        {
            itemImageSrc: projectBaseUrl+'Architecture/Jabir Residence/15 GF CP.jpg',
            thumbnailImageSrc: projectBaseUrl+'Architecture/Jabir Residence/15 GF CP.jpg',
            alt: '3D exterior rendering for buildings',
            title: 'Ground floor CP'
        },
        {
            itemImageSrc: projectBaseUrl+'Architecture/Jabir Residence/16 FF CP.jpg',
            thumbnailImageSrc: projectBaseUrl+'Architecture/Jabir Residence/16 FF CP.jpg',
            alt: 'exterior design for duplex houses in India',
            title: 'First floor cP'
        },
        {
            itemImageSrc: projectBaseUrl+'Architecture/Jabir Residence/17 GF WD.jpg',
            thumbnailImageSrc: projectBaseUrl+'Architecture/Jabir Residence/17 GF WD.jpg',
            alt: 'house front design with balcony and garden',
            title: 'Ground floor WD'
        },
        {
            itemImageSrc: projectBaseUrl+'Architecture/Jabir Residence/18 FF WD.jpg',
            thumbnailImageSrc: projectBaseUrl+'Architecture/Jabir Residence/18 FF WD.jpg',
            alt: 'contemporary exterior designs for villas',
            title: 'First floor WD'
        },
        {
            itemImageSrc: projectBaseUrl+'Architecture/Jabir Residence/19 Staircase.jpg',
            thumbnailImageSrc: projectBaseUrl+'Architecture/Jabir Residence/19 Staircase.jpg',
            alt: 'front elevation design',
            title: 'Staircase'
        },
        {
            itemImageSrc: projectBaseUrl+'Architecture/Jabir Residence/20 BAY WINDOW.jpg',
            thumbnailImageSrc: projectBaseUrl+'Architecture/Jabir Residence/20 BAY WINDOW.jpg',
            alt: 'facade design',
            title: 'BAY WINDOW'
        },
        {
            itemImageSrc: projectBaseUrl+'Architecture/Jabir Residence/21 GF ELC.jpg',
            thumbnailImageSrc: projectBaseUrl+'Architecture/Jabir Residence/21 GF ELC.jpg',
            alt: 'exterior remodeling',
            title: 'Ground floor Electrical'
        },
        {
            itemImageSrc: projectBaseUrl+'Architecture/Jabir Residence/22 FF ELC.jpg',
            thumbnailImageSrc: projectBaseUrl+'Architecture/Jabir Residence/22 FF ELC.jpg',
            alt: 'exterior renovation services',
            title: 'First floor Electrical'
        },
        {
            itemImageSrc: projectBaseUrl+'Architecture/Jabir Residence/23 Residence design to photo.jpg',
            thumbnailImageSrc: projectBaseUrl+'Architecture/Jabir Residence/23 Residence design to photo.jpg',
            alt: 'exterior landscape and lighting design',
            title: 'Residence design'
        },
    
    ],
        description:"test description fsdfsdf sdf dsf dsf sd fds f dsf sdfsdfsdf sdf sd fs dfds fsd f dsf ds fsd fs df sf",
        type:"architecture",
        duration:"2",
        purpose:"residential",
        client:"Aleen nagar"
    },
    {
        name: "Kaja Mohaideen",
        image: [{
            itemImageSrc: projectBaseUrl + 'Architecture/Kaja mohaideen/11 residence Desidn.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Kaja mohaideen/11 residence Desidn.jpg',
            alt: 'exterior remodeling',
            title: ''
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Kaja mohaideen/12 gf cp.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Kaja mohaideen/12 gf cp.jpg',
            alt: 'exterior renovation services',
            title: 'Ground floor CP'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Kaja mohaideen/13 staircase.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Kaja mohaideen/13 staircase.jpg',
            alt: 'exterior landscape and lighting design',
            title: 'Staircase'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Kaja mohaideen/14 elec.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Kaja mohaideen/14 elec.jpg',
            alt: 'Electrical Drawing',
            title: 'Electrical Drawing'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Kaja mohaideen/15 Interior.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Kaja mohaideen/15 Interior.jpg',
            alt: 'bungalow exterior design',
            title: 'Interior'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Kaja mohaideen/16  Exterior photo.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Kaja mohaideen/16  Exterior photo.jpg',
            alt: 'jb architects and engineers',
            title: 'Exterior photo'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Kaja mohaideen/17 residence design to photo.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Kaja mohaideen/17 residence design to photo.jpg',
            alt: 'architects in tirunelveli',
            title: '17 residence design to photo'
        },

        ],
        description: "test description fsdfsdf sdf dsf dsf sd fds f dsf sdfsdfsdf sdf sd fs dfds fsd f dsf ds fsd fs df sf",
        type: "architecture",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Kurichchi Complex",
        image: [{
            itemImageSrc: projectBaseUrl + 'Architecture/Kurichchi Complex/11 Comercial Complex design.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Kurichchi Complex/11 Comercial Complex design.jpg',
            alt: 'top architects consultant in tirunelveli',
            title: 'Comercial Complex design'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Kurichchi Complex/12 Floor plan.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Kurichchi Complex/12 Floor plan.jpg',
            alt: 'engineering firms in tirunelveli',
            title: 'Floor plan'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Kurichchi Complex/13 Pergola Design.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Kurichchi Complex/13 Pergola Design.jpg',
            alt: 'best architects in tirunelveli',
            title: 'Pergola Design'
        },

        ],
        description: "test description fsdfsdf sdf dsf dsf sd fds f dsf sdfsdfsdf sdf sd fs dfds fsd f dsf ds fsd fs df sf",
        type: "architecture",
        duration: "2",
        purpose: "jb architects and engineers tirunelveli",
        client: "Aleen nagar"
    },
    {
        name: "Madarassa",
        image: [{
            itemImageSrc: projectBaseUrl + 'Architecture/Madarassa/11 Madarassa Exterior design.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Madarassa/11 Madarassa Exterior design.jpg',
            alt: 'best architects for your dream home',
            title: 'Madarassa Exterior design'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Madarassa/12 gf cp.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Madarassa/12 gf cp.jpg',
            alt: 'Interior Designers',
            title: 'Ground Floor'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Madarassa/13 ff cp.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Madarassa/13 ff cp.jpg',
            alt: 'home renovation',
            title: 'First Floor CP'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Madarassa/14 sf cp.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Madarassa/14 sf cp.jpg',
            alt: 'best interior designers',
            title: 'Second Floor CP'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Madarassa/15 gf wd.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Madarassa/15 gf wd.jpg',
            alt: 'Residential Interior Design',
            title: 'Ground Floor WD'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Madarassa/16 staircase drawing.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Madarassa/16 staircase drawing.jpg',
            alt: 'commercial interior design',
            title: 'Staircase drawing'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Madarassa/17 Electrical drawing.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Madarassa/17 Electrical drawing.jpg',
            alt: 'Modern Interior Design',
            title: 'Electrical drawing'
        },

        ],
        description: "test description fsdfsdf sdf dsf dsf sd fds f dsf sdfsdfsdf sdf sd fs dfds fsd f dsf ds fsd fs df sf",
        type: "architecture",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Murugesh Residence",
        image: [{
            itemImageSrc: projectBaseUrl + 'Architecture/Murugesh Residence/11 Residence elevation design.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Murugesh Residence/11 Residence elevation design.jpg',
            alt: 'Affordable architects',
            title: 'Residence elevation design'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Murugesh Residence/12 EXterior photo.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Murugesh Residence/12 EXterior photo.jpg',
            alt: 'top architecture firms in tirunelveli',
            title: 'EXterior'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Murugesh Residence/13 gf residence plan.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Murugesh Residence/13 gf residence plan.jpg',
            alt: 'architects engineers near me',
            title: 'Ground floor residence plan'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Murugesh Residence/14 gf wd.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Murugesh Residence/14 gf wd.jpg',
            alt: 'tirunelveli architectural services',
            title: 'Ground floor wd'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Murugesh Residence/15 gf fp.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Murugesh Residence/15 gf fp.jpg',
            alt: 'affordable architectural design for homes',
            title: 'Ground floor fp'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Murugesh Residence/16 staircase drawing.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Murugesh Residence/16 staircase drawing.jpg',
            alt: 'modern house designs by architects',
            title: 'Staircase drawing'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Murugesh Residence/17 electrical drawing.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Murugesh Residence/17 electrical drawing.jpg',
            alt: 'architecture and engineering firm near me',
            title: 'Electrical drawing'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Murugesh Residence/18 ff cp.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Murugesh Residence/18 ff cp.jpg',
            alt: 'home exterior design',
            title: 'First Floor cp'
        },

        ],
        description: "test description fsdfsdf sdf dsf dsf sd fds f dsf sdfsdfsdf sdf sd fs dfds fsd f dsf ds fsd fs df sf",
        type: "architecture",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Prabu Residence",
        image: [{
            itemImageSrc: projectBaseUrl + 'Architecture/Prabu Residence/11 Residence exterior design.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Prabu Residence/11 Residence exterior design.jpg',
            alt: 'Residence exterior design',
            title: 'Residence exterior design'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Prabu Residence/12 Residence concept plan.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Prabu Residence/12 Residence concept plan.jpg',
            alt: 'Residence concept plan',
            title: 'Residence concept plan'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Prabu Residence/13 gf cp.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Prabu Residence/13 gf cp.jpg',
            alt: 'commercial exterior design',
            title: 'Ground floor cp'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Prabu Residence/14 Residence staircase.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Prabu Residence/14 Residence staircase.jpg',
            alt: 'exterior architectural design',
            title: 'Residence staircase'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Prabu Residence/15 Elevation drawing.JPG',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Prabu Residence/15 Elevation drawing.JPG',
            alt: 'house front elevation design',
            title: 'Elevation drawing'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Prabu Residence/16 ceiling plan.JPG',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Prabu Residence/16 ceiling plan.JPG',
            alt: '3D exterior design',
            title: 'Ceiling plan'
        },

        ],
        description: "test description fsdfsdf sdf dsf dsf sd fds f dsf sdfsdfsdf sdf sd fs dfds fsd f dsf ds fsd fs df sf",
        type: "architecture",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Praveen rajapalayam",
        image: [{
            itemImageSrc: projectBaseUrl + 'Architecture/Praveen rajapalayam/11 House elevation.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Praveen rajapalayam/11 House elevation.jpg',
            alt: 'building exterior design',
            title: 'House elevation'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Praveen rajapalayam/12 House plan.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Praveen rajapalayam/12 House plan.jpg',
            alt: 'exterior designers in Tirunelveli',
            title: 'House plan'
        },

        ],
        description: "test description fsdfsdf sdf dsf dsf sd fds f dsf sdfsdfsdf sdf sd fs dfds fsd f dsf ds fsd fs df sf",
        type: "architecture",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    
    {
        name: "Sahul palay residence",
        image: [{
            itemImageSrc: projectBaseUrl + 'Architecture/Sahul palay residence/11 Narrow residence.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Sahul palay residence/11 Narrow residence.jpg',
            alt: 'modern house exterior design Tirunelveli',
            title: 'Narrow residence'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Sahul palay residence/12 Compact Residence plan.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Sahul palay residence/12 Compact Residence plan.jpg',
            alt: 'Tirunelveli exterior design company',
            title: 'Compact Residence plan'
        },

        ],
        description: "test description fsdfsdf sdf dsf dsf sd fds f dsf sdfsdfsdf sdf sd fs dfds fsd f dsf ds fsd fs df sf",
        type: "architecture",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Salahudeen",
        image: [{
            itemImageSrc: projectBaseUrl + 'Architecture/Salahudeen/11 Residence exterior design.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Salahudeen/11 Residence exterior design.jpg',
            alt: 'front elevation designers in Tirunelveli',
            title: '11 Residence exterior design'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Salahudeen/12 Home plan.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Salahudeen/12 Home plan.jpg',
            alt: 'top exterior architects near me',
            title: 'Home plan'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Salahudeen/13 Elevation photo.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Salahudeen/13 Elevation photo.jpg',
            alt: 'home exterior design Tirunelveli',
            title: 'Elevation'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Salahudeen/14 Hall painting design.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Salahudeen/14 Hall painting design.jpg',
            alt: 'home exterior design Tirunelveli',
            title: 'Hall painting design'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Salahudeen/15 House design to photo.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Salahudeen/15 House design to photo.jpg',
            alt: 'affordable exterior design for small homes',
            title: 'House design'
        },

        ],
        description: "test description fsdfsdf sdf dsf dsf sd fds f dsf sdfsdfsdf sdf sd fs dfds fsd f dsf ds fsd fs df sf",
        type: "architecture",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Shoping complex",
        image: [{
            itemImageSrc: projectBaseUrl + 'Architecture/Shooping complex/11 Complex elevation design.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Shooping complex/11 Complex elevation design.jpg',
            alt: 'modern front elevation ideas for Indian homes',
            title: 'Complex elevation design'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Shooping complex/12 Complex plan.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Shooping complex/12 Complex plan.jpg',
            alt: '3D exterior rendering for buildings',
            title: 'Complex plan'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Shooping complex/13 elevation photo.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Shooping complex/13 elevation photo.jpg',
            alt: 'exterior design for duplex houses in India',
            title: 'Elevation'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Shooping complex/14 Exterior photo.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Shooping complex/14 Exterior photo.jpg',
            alt: 'house front design with balcony and garden',
            title: 'Exterior'
        },

        ],
        description: "test description fsdfsdf sdf dsf dsf sd fds f dsf sdfsdfsdf sdf sd fs dfds fsd f dsf ds fsd fs df sf",
        type: "architecture",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Suththamalli residence",
        image: [{
            itemImageSrc: projectBaseUrl + 'Architecture/Suththamalli residence/11 Elevation.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Suththamalli residence/11 Elevation.jpg',
            alt: 'contemporary exterior designs for villas',
            title: 'Elevation'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Suththamalli residence/12 Residence plan.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Suththamalli residence/12 Residence plan.jpg',
            alt: 'front elevation design',
            title: 'Residence plan'
        },

        ],
        description: "test description fsdfsdf sdf dsf dsf sd fds f dsf sdfsdfsdf sdf sd fs dfds fsd f dsf ds fsd fs df sf",
        type: "architecture",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Virudunagar",
        image: [{
            itemImageSrc: projectBaseUrl + 'Architecture/Virudunagar/11 Mansion Exterior 11.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Virudunagar/11 Mansion Exterior 11.jpg',
            alt: 'facade design',
            title: 'Mansion Exterior'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Virudunagar/12 gf cp.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Virudunagar/12 gf cp.jpg',
            alt: 'exterior remodeling',
            title: 'Ground Floor cp'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Virudunagar/13 ff cp.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Virudunagar/13 ff cp.jpg',
            alt: 'exterior renovation services',
            title: 'First floor cp'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Virudunagar/14 sf cp.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Virudunagar/14 sf cp.jpg',
            alt: 'exterior landscape and lighting design',
            title: 'Second floor cp'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Virudunagar/15 gf wd.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Virudunagar/15 gf wd.jpg',
            alt: 'bungalow exterior design',
            title: 'Ground Floor wd'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Virudunagar/16 ff wd.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Virudunagar/16 ff wd.jpg',
            alt: 'First floor wd',
            title: 'First floor wd'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Virudunagar/17 staircase detail.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Virudunagar/17 staircase detail.jpg',
            alt: 'Staircase detail',
            title: 'Staircase detail'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Virudunagar/18 Elevation deatils.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Virudunagar/18 Elevation deatils.jpg',
            alt: 'Elevation details',
            title: 'Elevation details'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Virudunagar/19 room drawing.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Virudunagar/19 room drawing.jpg',
            alt: 'Room drawing',
            title: 'Room drawing'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Virudunagar/19 room plan.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Virudunagar/19 room plan.jpg',
            alt: 'Room plan',
            title: 'Room plan'
        },

        ],
        description: "test description fsdfsdf sdf dsf dsf sd fds f dsf sdfsdfsdf sdf sd fs dfds fsd f dsf ds fsd fs df sf",
        type: "architecture",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Virudunagar Residence",
        image: [{
            itemImageSrc: projectBaseUrl + 'Architecture/Virudunagar Residence/11 Residence Exterior ch 2.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Virudunagar Residence/11 Residence Exterior ch 2.jpg',
            alt: 'Residence Exterior',
            title: 'Residence Exterior'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Virudunagar Residence/12 gf cp.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Virudunagar Residence/12 gf cp.jpg',
            alt: 'Ground Floor cp',
            title: 'Ground Floor cp'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Virudunagar Residence/13 elev.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Virudunagar Residence/13 elev.jpg',
            alt: 'Elevation',
            title: 'Elevation'
        },
        {
            itemImageSrc: projectBaseUrl + 'Architecture/Virudunagar Residence/13 Elevation detail.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Architecture/Virudunagar Residence/13 Elevation detail.jpg',
            alt: 'Elevation detail',
            title: 'Elevation detail'
        },

        ],
        description: "test description fsdfsdf sdf dsf dsf sd fds f dsf sdfsdfsdf sdf sd fs dfds fsd f dsf ds fsd fs df sf",
        type: "architecture",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Grand Bridal Entrance Design",
        image: [{
            itemImageSrc: projectBaseUrl + 'Interior/222.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Interior/222.jpg',
            alt: 'Enderence',
            title: 'Grand Bridal Entrance Design'
        },
        ],
        description: "This architectural design features a stunning and elegant entrance, ideal for a bridal boutique or wedding venue. The grand archway is accentuated with curved wooden elements, intricate lattice panels, and soft ambient lighting, creating a warm and inviting atmosphere. The symmetrical side panels with ornamental patterns add a touch of sophistication, while the illuminated shelves enhance the aesthetic appeal. The 'BRIDAL' signage at the top highlights the entrance’s purpose, making it a focal point for guests and customers. This design blends modern elegance with classic charm, making it perfect for a luxurious wedding-themed space.",
        type: "interior",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Elegant Modern Living Room Design",
        image: [{
            itemImageSrc: projectBaseUrl + 'Interior/An 1 To print.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Interior/An 1 To print.jpg',
            alt: 'Enderence',
            title: 'Elegant Modern Living Room Design'
        },
        ],
        description: "This living room design showcases a perfect blend of modern aesthetics and functional elegance. The soft beige walls complement the grey-toned furniture, creating a warm and inviting ambiance. Natural light flows through large windows adorned with stylish drapes, enhancing the room’s spacious feel. A sleek false ceiling with recessed lighting and contemporary pendant fixtures adds depth and sophistication. The accent wall with floating shelves and framed artwork provides a touch of personality, while the minimalistic coffee table anchors the space beautifully. This well-balanced interior design is ideal for those seeking comfort with a refined, contemporary touch.",
        type: "interior",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Contemporary TV Unit & Living Space Design",
        image: [{
            itemImageSrc: projectBaseUrl + 'Interior/An 2 To print.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Interior/An 2 To print.jpg',
            alt: 'Enderence',
            title: 'Contemporary TV Unit & Living Space Design'
        },
        ],
        description: "This modern living space design seamlessly blends style and functionality. The focal point is the elegantly designed TV unit, featuring a textured 3D accent wall that adds depth and character to the room. The sleek, floating shelves and storage units provide both aesthetic appeal and practicality, offering space for books, decor, and entertainment essentials. The ceiling design incorporates recessed lighting and hanging pendant lights, enhancing the contemporary ambiance. The combination of soft beige tones, dark contrasts, and natural elements like artwork and plants creates a balanced and inviting atmosphere, making this an ideal entertainment and relaxation zone.",
        type: "interior",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Modern Modular Wardrobe Design",
        image: [{
            itemImageSrc: projectBaseUrl + 'Interior/An 3.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Interior/An 3.jpg',
            alt: 'Enderence',
            title: 'Modern Modular Wardrobe Design'
        },
        ],
        description: "This sleek and contemporary modular wardrobe features a striking red and white color combination, adding a vibrant yet elegant touch to the space. Designed for maximum functionality, it includes multiple storage compartments such as overhead cabinets, drawers, open shelves, and dedicated hanging sections. The glossy laminate finish enhances brightness and creates a reflective effect, making the room appear more spacious. Ideal for modern interiors, this wardrobe seamlessly blends aesthetics with practicality, offering an organized and stylish storage solution.",
        type: "interior",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Stylish Bedroom Interior with Floral Accent Wall",
        image: [{
            itemImageSrc: projectBaseUrl + 'Interior/Ang 1 fn.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Interior/Ang 1 fn.jpg',
            alt: 'Enderence',
            title: 'Stylish Bedroom Interior with Floral Accent Wall'
        },
        ],
        description: "This modern bedroom design features a harmonious blend of soft pastels and bold floral accents, creating a lively yet relaxing ambiance. The vibrant red and black floral wall panels add a striking contrast against the soft pink hues, bringing a dynamic visual appeal. A sleek black wardrobe with a glossy finish enhances the room's contemporary style, while a wooden cabinet tucked into the niche maximizes space utilization. The thoughtfully placed furniture and color-coordinated elements contribute to a cozy and aesthetically pleasing atmosphere, perfect for a stylish and comfortable living",
        type: "interior",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Contemporary Bedroom Design with Integrated Storage",
        image: [{
            itemImageSrc: projectBaseUrl + 'Interior/Ang 2 fn.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Interior/Ang 2 fn.jpg',
            alt: 'Enderence',
            title: 'Contemporary Bedroom Design with Integrated Storage'
        },
        ],
        description: "This modern bedroom seamlessly blends functionality and aesthetics, offering a stylish and comfortable space. The striking floral accent wall in red, black, and white adds vibrancy, creating a dynamic contrast against the soft pastel tones. The built-in storage shelves provide ample space for organization while maintaining a sleek and clutter-free environment. The custom-designed door with a bold red frame enhances the room’s modern appeal. Thoughtfully designed with a cozy bed setup and carefully curated color combinations, this bedroom is a perfect blend of elegance and practicality.",
        type: "interior",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Elegant Modern Staircase Design",
        image: [{
            itemImageSrc: projectBaseUrl + 'Interior/Angle 1 FN.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Interior/Angle 1 FN.jpg',
            alt: 'Enderence',
            title: 'Elegant Modern Staircase Design'
        },
        ],
        description: "This 3D-rendered staircase design combines contemporary aesthetics with functional efficiency. Featuring a sleek wooden handrail with glass panel inserts, it enhances openness and natural light flow. The floating stair treads provide a visually striking appeal, while the neutral color palette ensures seamless integration with the surrounding space. Designed for both style and safety, this staircase is a perfect choice for modern interiors, offering durability and elegance in a minimalistic form.",
        type: "interior",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Modern Café Interior with Greenery and Contemporary Design",
        image: [{
            itemImageSrc: projectBaseUrl + 'Interior/Angle 1.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Interior/Angle 1.jpg',
            alt: 'Enderence',
            title: 'Modern Café Interior with Greenery and Contemporary Design'
        },
        ],
        description: "This café interior blends modern aesthetics with a refreshing natural touch, creating a welcoming and stylish ambiance. The space features exposed brick walls, a lush vertical green garden, and warm wooden flooring, offering a perfect balance of urban and organic elements. The neon 'Be Cool' sign enhances the trendy vibe, making it an ideal hangout spot. The seating arrangement includes a mix of comfortable yellow chairs and sleek bar stools, catering to both casual and formal dining experiences. The counter area is highlighted by industrial-style pendant lights, adding warmth and elegance. Thoughtful design details, such as the integrated sink and well-placed decor elements, enhance functionality while maintaining aesthetic appeal. This café interior design is a perfect blend of comfort, style, and sustainability, ensuring a memorable experience for customers.",
        type: "interior",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Elegant Modern Staircase with Glass and Wood Design",
        image: [{
            itemImageSrc: projectBaseUrl + 'Interior/Angle 2 FN.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Interior/Angle 2 FN.jpg',
            alt: 'Enderence',
            title: 'Elegant Modern Staircase with Glass and Wood Design'
        },
        ],
        description: "This beautifully designed staircase seamlessly blends modern aesthetics with functionality. Featuring a combination of rich wooden steps, sleek glass railings, and warm LED lighting, it enhances the overall elegance of the space. The minimalistic yet sturdy structure provides both safety and style, making it a perfect addition to contemporary interiors. The transparent glass panels allow light to flow through, creating an open and airy ambiance, while the wooden elements add warmth and sophistication. The strategically placed LED lighting not only elevates the visual appeal but also ensures safety by illuminating each step. This staircase design exemplifies luxury and modernity, making it a standout architectural feature in any home or commercial space.",
        type: "interior",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Modern Café Interior with a Vibrant and Cozy Ambience",
        image: [{
            itemImageSrc: projectBaseUrl + 'Interior/Angle 2.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Interior/Angle 2.jpg',
            alt: 'Enderence',
            title: 'Modern Café Interior with a Vibrant and Cozy Ambience'
        },
        ],
        description: "This contemporary café interior is designed to offer a welcoming and stylish atmosphere. The combination of textured brick walls, lush greenery, and warm wooden flooring creates a perfect blend of modern aesthetics and natural elements. The bright yellow seating adds a lively contrast, enhancing the overall vibrancy of the space. The strategic placement of lighting ensures a well-lit and inviting environment, while the framed wall art and decorative accents contribute to a trendy, urban feel. The café layout is thoughtfully designed for comfort, with well-spaced tables and a dedicated seating nook for a more intimate dining experience. This interior concept not only enhances the visual appeal but also ensures a relaxing and enjoyable setting for customers, making it an ideal spot for casual dining and social gatherings.",
        type: "interior",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Elegant Private Dining Space with a Natural Touch",
        image: [{
            itemImageSrc: projectBaseUrl + 'Interior/Angle 3.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Interior/Angle 3.jpg',
            alt: 'Enderence',
            title: 'Elegant Private Dining Space with a Natural Touch'
        },
        ],
        description: "This beautifully designed private dining area offers a perfect blend of modern sophistication and natural elements. The combination of exposed brick walls, lush greenery, and warm wooden flooring creates a cozy yet stylish ambiance. The black pendant lights add a contemporary touch, enhancing the intimate atmosphere, while the framed artwork on the accent wall provides a refined aesthetic. The sleek dining table, paired with bold yellow chairs, creates a striking contrast, making the space both inviting and visually dynamic. Ideal for intimate gatherings or private dining experiences, this space ensures comfort, elegance, and a refreshing connection with nature.",
        type: "interior",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Luxurious Living Space with Elegant Interiors",
        image: [{
            itemImageSrc: projectBaseUrl + 'Interior/AP Living Room Angle 1.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Interior/AP Living Room Angle 1.jpg',
            alt: 'Enderence',
            title: 'Luxurious Living Space with Elegant Interiors'
        },
        ],
        description: "This exquisitely designed living room seamlessly blends classic elegance with modern aesthetics. The rich wooden elements, intricate ceiling design, and sophisticated lighting fixtures create a warm and inviting atmosphere.The plush, vintage-style blue sofas add a touch of royal charm, perfectly complementing the contemporary marble flooring and wooden accents. The open-concept layout effortlessly connects the living area to the dining space, where a statement chandelier and textured wall design enhance the luxurious appeal. Perfect for both relaxation and social gatherings, this space offers a harmonious balance of comfort and style.",
        type: "interior",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Modern & Elegant Bakery Interior Design",
        image: [{
            itemImageSrc: projectBaseUrl + 'Interior/Bakery Interior.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Interior/Bakery Interior.jpg',
            alt: 'Enderence',
            title: 'Modern & Elegant Bakery Interior Design'
        },
        ],
        description: "This contemporary bakery interior blends style and functionality, creating an inviting atmosphere for customers. The sleek glass display showcases a variety of delicious baked goods, while warm wooden accents and geometric wall patterns add a touch of sophistication. Thoughtfully placed pendant lights enhance the ambiance, making the space feel cozy yet modern. The use of neutral tones, combined with subtle golden highlights, provides a luxurious feel. Wall-mounted counters offer convenience for quick service, ensuring a seamless customer experience.erfectly designed for efficiency and aesthetics, this bakery layout maximizes space while maintaining an elegant and welcoming environment.",
        type: "interior",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Modern Bank Ceiling Design",
        image: [{
            itemImageSrc: projectBaseUrl + 'Interior/Bank Ceiling 1.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Interior/Bank Ceiling 1.jpg',
            alt: 'Enderence',
            title: 'Modern Bank Ceiling Design'
        },
        ],
        description: "This contemporary bank ceiling design incorporates sleek geometric patterns with a combination of recessed lighting and LED strip accents. The neutral-toned panels, highlighted by a contrasting white frame, create a sophisticated yet professional atmosphere. The 3D lettering adds a branding element, ensuring the ceiling serves both aesthetic and functional purposes. Strategic placement of warm yellow lighting enhances the ambiance while maintaining a professional look. This design is ideal for financial institutions seeking a balance between modern elegance and a welcoming customer experience.",
        type: "interior",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Morden closet with TV unit design",
        image: [{
            itemImageSrc: projectBaseUrl + 'Interior/BB Ang 2 with mirror.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Interior/BB Ang 2 with mirror.jpg',
            alt: 'Enderence',
            title: 'Morden closet with TV unit design'
        },
        ],
        description: "",
        type: "interior",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Bell Bakery",
        image: [{
            itemImageSrc: projectBaseUrl + 'Interior/Bell Bakery An 1.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Interior/Bell Bakery An 1.jpg',
            alt: 'Enderence',
            title: 'Bell Bakery'
        },
        {
            itemImageSrc: projectBaseUrl + 'Interior/Bell Bakery An 2.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Interior/Bell Bakery An 2.jpg',
            alt: 'Enderence',
            title: 'Bell Bakery'
        },
        ],
        description: "",
        type: "interior",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Clinic Interior",
        image: [{
            itemImageSrc: projectBaseUrl + 'Interior/Clinic Interior.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Interior/Clinic Interior.jpg',
            alt: 'Enderence',
            title: 'Clinic Interior'
        },
        ],
        description: "",
        type: "interior",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Clinic Top view",
        image: [{
            itemImageSrc: projectBaseUrl + 'Interior/Clinic Top view.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Interior/Clinic Top view.jpg',
            alt: 'Enderence',
            title: 'Clinic Top view'
        },
        ],
        description: "",
        type: "interior",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Counter Design",
        image: [{
            itemImageSrc: projectBaseUrl + 'Interior/counter.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Interior/counter.jpg',
            alt: 'Enderence',
            title: 'Counter Design'
        },
        ],
        description: "",
        type: "interior",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Dressing Wardrobe",
        image: [{
            itemImageSrc: projectBaseUrl + 'Interior/Dressing Wardrobe.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Interior/Dressing Wardrobe.jpg',
            alt: 'Enderence',
            title: 'Dressing Wardrobe'
        },
        ],
        description: "",
        type: "interior",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Textile shop Entry",
        image: [{
            itemImageSrc: projectBaseUrl + 'Interior/entry.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Interior/entry.jpg',
            alt: 'Enderence',
            title: 'Textile shop Entry'
        },
        ],
        description: "",
        type: "interior",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "LIQUIDZZ We3 Foodvanture",
        image: [{
            itemImageSrc: projectBaseUrl + 'Interior/Exterior.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Interior/Exterior.jpg',
            alt: 'Enderence',
            title: 'LIQUIDZZ We3 Foodvanture'
        },
        ],
        description: "",
        type: "interior",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    }, 
    {
        name: "Modern Hall design",
        image: [{
            itemImageSrc: projectBaseUrl + 'Interior/FF Hall A1.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Interior/FF Hall A1.jpg',
            alt: 'Enderence',
            title: 'Modern Hall design'
        },
        {
            itemImageSrc: projectBaseUrl + 'Interior/FF Hall A2.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Interior/FF Hall A2.jpg',
            alt: 'Enderence',
            title: 'Modern Hall design'
        },
        ],
        description: "",
        type: "interior",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Biophilic Office Interior Design",
        image: [{
            itemImageSrc: projectBaseUrl + 'Interior/Final.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Interior/Final.jpg',
            alt: 'Enderence',
            title: 'Biophilic Office Interior Design'
        },
        ],
        description: "This modern office space integrates biophilic design elements, creating a refreshing and sophisticated workspace. The feature wall showcases a unique combination of greenery, textured stone, and backlit panels, enhancing the ambiance with natural elements. The ceiling incorporates curved paneling with recessed lighting, complemented by wooden textures, adding warmth to the space. The sleek, minimalistic furniture with dark wood finishes and ergonomic seating ensures both functionality and aesthetic appeal. This design is ideal for offices looking to foster a welcoming, nature-inspired, and productive environment",
        type: "interior",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    }, 
    {
        name: "Modern Living Room Interior Design with Elegant Features",
        image: [{
            itemImageSrc: projectBaseUrl + 'Interior/Hall Ang 1.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Interior/Hall Ang 1.jpg',
            alt: 'Enderence',
            title: 'Modern Living Room Interior Design with Elegant Features'
        },
        ],
        description: "This living room interior design showcases a perfect blend of aesthetics and functionality, creating a sophisticated and inviting ambiance. The space is designed with a modern approach, incorporating various elements that enhance both visual appeal and comfort.",
        type: "interior",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Luxurious Double-Height Living Room with Contemporary Elegance",
        image: [{
            itemImageSrc: projectBaseUrl + 'Interior/HALL INTERIOR A2.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Interior/HALL INTERIOR A2.jpg',
            alt: 'Enderence',
            title: 'Luxurious Double-Height Living Room with Contemporary Elegance'
        },
        ],
        description: "This stunning double-height living room exemplifies modern elegance and spaciousness. Designed with a sophisticated mix of materials, textures, and lighting, the space exudes a sense of grandeur while maintaining a cozy ambiance.",
        type: "interior",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "HALL INTERIOR",
        image: [{
            itemImageSrc: projectBaseUrl + 'Interior/HALL INTERIOR A3.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Interior/HALL INTERIOR A3.jpg',
            alt: 'Enderence',
            title: 'HALL INTERIOR'
        },
        ],
        description: "",
        type: "interior",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Elegant Contemporary Hall Interior Design ",
        image: [{
            itemImageSrc: projectBaseUrl + 'Interior/jUNAngle 1.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Interior/jUNAngle 1.jpg',
            alt: 'Enderence',
            title: 'Elegant Contemporary Hall Interior Design '
        },
        {
            itemImageSrc: projectBaseUrl + 'Interior/JUN Angle 2.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Interior/JUN Angle 2.jpg',
            alt: 'Enderence',
            title: 'Elegant Contemporary Hall Interior Design '
        },
        {
            itemImageSrc: projectBaseUrl + 'Interior/JUN Angle 3.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Interior/JUN Angle 3.jpg',
            alt: 'Enderence',
            title: 'Elegant Contemporary Hall Interior Design '
        },
        ],
        description: "",
        type: "interior",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Kids Room Design",
        image: [{
            itemImageSrc: projectBaseUrl + 'Interior/Kids room Final.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Interior/Kids room Final.jpg',
            alt: 'Enderence',
            title: 'Kids Room Design'
        },
        ],
        description: "",
        type: "interior",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Sleek and Modern Modular Kitchen Design",
        image: [{
            itemImageSrc: projectBaseUrl + 'Interior/Kitchen Final ch.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Interior/Kitchen Final ch.jpg',
            alt: 'Enderence',
            title: 'Sleek and Modern Modular Kitchen Design'
        },
        ],
        description: "This contemporary modular kitchen design blends functionality with elegance, creating a sophisticated yet practical cooking space. The combination of black and white marble-finish cabinetry enhances the modern aesthetic while ensuring durability and ease of maintenance.",
        type: "interior",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Elegant Living Space with a Blend of Modern and Rustic Charm",
        image: [{
            itemImageSrc: projectBaseUrl + 'Interior/living 1 final ed.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Interior/living 1 final ed.jpg',
            alt: 'Enderence',
            title: "Elegant Living Space with a Blend of Modern and Rustic Charm"
        },
        {
            itemImageSrc: projectBaseUrl + 'Interior/living 2 final ed.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Interior/living 2 final ed.jpg',
            alt: 'Enderence',
            title: "Elegant Living Space with a Blend of Modern and Rustic Charm"
        },
        ],
        description: "This beautifully designed living space seamlessly combines modern aesthetics with a touch of rustic charm. The exposed brick accent wall adds warmth and character, complementing the sleek false ceiling with recessed lighting that enhances the ambiance. The wooden flooring lends a rich and inviting feel, while the vibrant yellow and white walls introduce a sense of energy and brightness. Strategically placed windows ensure ample natural light, creating an open and airy atmosphere. The furniture layout is both stylish and functional, featuring contemporary seating arrangements that provide comfort and sophistication. The built-in display shelves, accented in red, serve as striking focal points for decorative pieces, adding a personalized touch to the room. Overall, this living space is thoughtfully designed to balance aesthetics and practicality, making it the perfect setting for relaxation and social gatherings.",
        type: "interior",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Pari kitchen",
        image: [{
            itemImageSrc: projectBaseUrl + 'Interior/Pari kitchen.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Interior/Pari kitchen.jpg',
            alt: 'Enderence',
            title: 'Pari kitchen'
        },
        ],
        description: "",
        type: "interior",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Railway Monitoring Room",
        image: [{
            itemImageSrc: projectBaseUrl + 'Interior/Railway ANG 1.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Interior/Railway ANG 1.jpg',
            alt: 'Enderence',
            title: 'Railway Monitoring Room'
        },
        {
            itemImageSrc: projectBaseUrl + 'Interior/Railway ANG 2.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Interior/Railway ANG 2.jpg',
            alt: 'Enderence',
            title: 'Railway Monitoring Room'
        },
        ],
        description: "",
        type: "interior",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Sabana Jewellary",
        image: [{
            itemImageSrc: projectBaseUrl + 'Interior/sabana jewellary ch.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Interior/sabana jewellary ch.jpg',
            alt: 'Enderence',
            title: 'Sabana Jewellary'
        },
        ],
        description: "",
        type: "interior",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Tea time Counter",
        image: [{
            itemImageSrc: projectBaseUrl + 'Interior/Tea time Counter.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Interior/Tea time Counter.jpg',
            alt: 'Enderence',
            title: 'Tea time Counter'
        },
        ],
        description: "",
        type: "interior",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Top View",
        image: [{
            itemImageSrc: projectBaseUrl + 'Interior/Top View Ch.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Interior/Top View Ch.jpg',
            alt: 'Enderence',
            title: 'Top View'
        },
        ],
        description: "",
        type: "interior",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "TV Unit design",
        image: [{
            itemImageSrc: projectBaseUrl + 'Interior/TV Unit design.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Interior/TV Unit design.jpg',
            alt: 'Enderence',
            title: 'TV Unit design'
        },
        ],
        description: "",
        type: "interior",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Modern L-Shaped Kitchen Design",
        image: [{
            itemImageSrc: projectBaseUrl + 'Interior/v1.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Interior/v1.jpg',
            alt: 'Enderence',
            title: 'Modern L-Shaped Kitchen'
        },
        {
            itemImageSrc: projectBaseUrl + 'Interior/v2.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Interior/v2.jpg',
            alt: 'Enderence',
            title: 'Modern L-Shaped Kitchen'
        },
        ],
        description: "This L-shaped kitchen design blends functionality with modern aesthetics, creating an ideal cooking space. The sleek dark wood cabinetry offers ample storage, while the polished countertops provide a spacious and durable work surface. The backsplash, adorned with food-themed tiles, adds a decorative yet practical touch, enhancing the ambiance. Key features include a well-positioned cooktop for easy meal preparation, a stainless steel sink with a modern faucet for convenience, and overhead cabinets for additional storage. The neutral color palette and minimalist design ensure a clean, sophisticated look that complements any home interior. Designed by Ar. Mohamed Hassim, this kitchen is a perfect combination of elegance and practicality, making it an excellent choice for homeowners seeking a stylish and efficient kitchen space.",
        type: "interior",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Aleem Nagar",
        image: [{
            itemImageSrc: projectBaseUrl + 'Consultant/Aleem nagar edit copy.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Consultant/Aleem nagar edit copy.jpg',
            alt: 'Enderence',
            title: 'Aleem Nagar'
        },
        ],
        description: "",
        type: "consultant",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Beauty Parlour",
        image: [{
            itemImageSrc: projectBaseUrl + 'Consultant/Beauty parlour poster.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Consultant/Beauty parlour poster.jpg',
            alt: 'Enderence',
            title: 'Beauty Parlour'
        },
        ],
        description: "",
        type: "consultant",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    
    {
        name: "Bed room copy",
        image: [{
            itemImageSrc: projectBaseUrl + 'Consultant/Bed room copy.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Consultant/Bed room copy.jpg',
            alt: 'Enderence',
            title: 'Bed room copy'
        },
        ],
        description: "",
        type: "consultant",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Ceiling",
        image: [{
            itemImageSrc: projectBaseUrl + 'Consultant/Ceiling img 1.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Consultant/Ceiling img 1.jpg',
            alt: 'Enderence',
            title: 'Ceiling'
        },
        {
            itemImageSrc: projectBaseUrl + 'Consultant/Ceiling img 2.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Consultant/Ceiling img 2.jpg',
            alt: 'Enderence',
            title: 'Ceiling'
        },
        ],
        description: "",
        type: "consultant",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Dental exterior",
        image: [{
            itemImageSrc: projectBaseUrl + 'Consultant/Dental exterior POST.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Consultant/Dental exterior POST.jpg',
            alt: 'Enderence',
            title: 'Dental exterior'
        },
        ],
        description: "",
        type: "consultant",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Dental Interior",
        image: [{
            itemImageSrc: projectBaseUrl + 'Consultant/Dental Interior post.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Consultant/Dental Interior post.jpg',
            alt: 'Enderence',
            title: 'Dental Interior'
        },
        ],
        description: "",
        type: "consultant",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Antek Safty System Exterior",
        image: [{
            itemImageSrc: projectBaseUrl + 'Consultant/Exterior  poster image.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Consultant/Exterior  poster image.jpg',
            alt: 'Enderence',
            title: 'Antek Safty System Exterior'
        },
        {
            itemImageSrc: projectBaseUrl + 'Consultant/Interior  poster image.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Consultant/Interior  poster image.jpg',
            alt: 'Enderence',
            title: 'Antek Safty System Interior'
        },
        ],
        description: "",
        type: "consultant",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Antek Safty System Interior",
        image: [
            {
                itemImageSrc: projectBaseUrl + 'Consultant/Interior  poster image.jpg',
                thumbnailImageSrc: projectBaseUrl + 'Consultant/Interior  poster image.jpg',
                alt: 'Enderence',
                title: 'Antek Safty System Interior'
            },
        ],
        description: "",
        type: "consultant",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Jabir Residence",
        image: [{
            itemImageSrc: projectBaseUrl + 'Consultant/Jabir residence copy.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Consultant/Jabir residence copy.jpg',
            alt: 'Enderence',
            title: 'Jabir Residence'
        },
        ],
        description: "",
        type: "consultant",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Kaja Residence",
        image: [{
            itemImageSrc: projectBaseUrl + 'Consultant/Kaja mama residence.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Consultant/Kaja mama residence.jpg',
            alt: 'Enderence',
            title: 'Kaja Residence'
        },
        ],
        description: "",
        type: "consultant",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Karungulam Residence",
        image: [{
            itemImageSrc: projectBaseUrl + 'Consultant/Karungulam Residence.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Consultant/Karungulam Residence.jpg',
            alt: 'Enderence',
            title: 'Karungulam Residence'
        },
        ],
        description: "",
        type: "consultant",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "P A Rasool Elevation",
        image: [{
            itemImageSrc: projectBaseUrl + 'Consultant/P A Rasool Elevation copy.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Consultant/P A Rasool Elevation copy.jpg',
            alt: 'Enderence',
            title: 'P A Rasool Elevation'
        },
        ],
        description: "",
        type: "consultant",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Pettai interior study table",
        image: [{
            itemImageSrc: projectBaseUrl + 'Consultant/Pettai interior study table .jpg',
            thumbnailImageSrc: projectBaseUrl + 'Consultant/Pettai interior study table .jpg',
            alt: 'Enderence',
            title: 'Pettai interior study table'
        },
        ],
        description: "",
        type: "consultant",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Sadam Residential",
        image: [{
            itemImageSrc: projectBaseUrl + 'Consultant/Sadam Residence.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Consultant/Sadam Residence.jpg',
            alt: 'Enderence',
            title: 'Sadam Residential'
        },
        ],
        description: "",
        type: "consultant",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Siraj Residence",
        image: [{
            itemImageSrc: projectBaseUrl + 'Consultant/Siraj residence copy.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Consultant/Siraj residence copy.jpg',
            alt: 'Enderence',
            title: 'Siraj Residence'
        },
        ],
        description: "",
        type: "consultant",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },

    // Commertial projects
    {
        name: "Balaji Complex",
        image: [{
            itemImageSrc: projectBaseUrl + 'Commercial/Balaji Complex.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Commercial/Balaji Complex.jpg',
            alt: 'Modern Interior Design',
            title: 'Clasic Residence Design'
        },

        ],
        description: "test description fsdfsdf sdf dsf dsf sd fds f dsf sdfsdfsdf sdf sd fs dfds fsd f dsf ds fsd fs df sf",
        type: "commercial",
        duration: "2",
        purpose: "residential",
        client: "Balaji"
    },
    {
        name: "Balaji Hall Exterior",
        image: [{
            itemImageSrc: projectBaseUrl + 'Commercial/Balaji Hall Exterior.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Commercial/Balaji Hall Exterior.jpg',
            alt: 'Modern Interior Design',
            title: 'Clasic Residence Design'
        },

        ],
        description: "test description fsdfsdf sdf dsf dsf sd fds f dsf sdfsdfsdf sdf sd fs dfds fsd f dsf ds fsd fs df sf",
        type: "commercial",
        duration: "2",
        purpose: "residential",
        client: "Balaji "
    },
    {
        name: "Chennai Silks Arch",
        image: [{
            itemImageSrc: projectBaseUrl + 'Commercial/Chennai Silks Arch opt 2.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Commercial/Chennai Silks Arch opt 2.jpg',
            alt: 'Modern Interior Design',
            title: 'Clasic Residence Design'
        },

        ],
        description: "test description fsdfsdf sdf dsf dsf sd fds f dsf sdfsdfsdf sdf sd fs dfds fsd f dsf ds fsd fs df sf",
        type: "commercial",
        duration: "2",
        purpose: "residential",
        client: "Chennai Silks"
    },
    {
        name: "ABC Complex",
        image: [{
            itemImageSrc: projectBaseUrl + 'Commercial/Complex OPT 3.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Commercial/Complex OPT 3.jpg',
            alt: 'Modern Interior Design',
            title: 'Clasic Residence Design'
        },

        ],
        description: "test description fsdfsdf sdf dsf dsf sd fds f dsf sdfsdfsdf sdf sd fs dfds fsd f dsf ds fsd fs df sf",
        type: "commercial",
        duration: "2",
        purpose: "residential",
        client: "Complex OPT"
    },
    {
        name: "St.Andrews Store",
        image: [{
            itemImageSrc: projectBaseUrl + 'Commercial/Day view.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Commercial/Day view.jpg',
            alt: 'Modern Interior Design',
            title: 'Clasic Residence Design'
        },{
            itemImageSrc: projectBaseUrl + 'Commercial/Night view 1.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Commercial/Night view 1.jpg',
            alt: 'Modern Interior Design',
            title: 'Clasic Residence Design'
        },

        ],
        description: "test description fsdfsdf sdf dsf dsf sd fds f dsf sdfsdfsdf sdf sd fs dfds fsd f dsf ds fsd fs df sf",
        type: "commercial",
        duration: "2",
        purpose: "residential",
        client: "Day view"
    },
    {
        name: "Darul Shifa",
        image: [{
            itemImageSrc: projectBaseUrl + 'Commercial/Dental clinic Exterior 3.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Commercial/Dental clinic Exterior 3.jpg',
            alt: 'Modern Interior Design',
            title: 'Clasic Residence Design'
        },

        ],
        description: "test description fsdfsdf sdf dsf dsf sd fds f dsf sdfsdfsdf sdf sd fs dfds fsd f dsf ds fsd fs df sf",
        type: "commercial",
        duration: "2",
        purpose: "residential",
        client: ""
    },
    {
        name: "Antek Safety System",
        image: [{
            itemImageSrc: projectBaseUrl + 'Commercial/Exterior day final.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Commercial/Exterior day final.jpg',
            alt: 'Modern Interior Design',
            title: 'Clasic Residence Design'
        },{
            itemImageSrc: projectBaseUrl + 'Commercial/Exterior night final1.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Commercial/Exterior night final1.jpg',
            alt: 'Modern Interior Design',
            title: 'Clasic Residence Design'
        },

        ],
        description: "test description fsdfsdf sdf dsf dsf sd fds f dsf sdfsdfsdf sdf sd fs dfds fsd f dsf ds fsd fs df sf",
        type: "commercial",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Liquidzz",
        image: [{
            itemImageSrc: projectBaseUrl + 'Commercial/Exterior.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Commercial/Exterior.jpg',
            alt: 'Modern Interior Design',
            title: 'Clasic Residence Design'
        },

        ],
        description: "test description fsdfsdf sdf dsf dsf sd fds f dsf sdfsdfsdf sdf sd fs dfds fsd f dsf ds fsd fs df sf",
        type: "commercial",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "JOE",
        image: [{
            itemImageSrc: projectBaseUrl + 'Commercial/Fancy store opt 2.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Commercial/Fancy store opt 2.jpg',
            alt: 'Modern Interior Design',
            title: 'Clasic Residence Design'
        },

        ],
        description: "test description fsdfsdf sdf dsf dsf sd fds f dsf sdfsdfsdf sdf sd fs dfds fsd f dsf ds fsd fs df sf",
        type: "commercial",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Studio'O7",
        image: [{
            itemImageSrc: projectBaseUrl + 'Commercial/FINAL  CH.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Commercial/FINAL  CH.jpg',
            alt: 'Modern Interior Design',
            title: 'Clasic Residence Design'
        },

        ],
        description: "test description fsdfsdf sdf dsf dsf sd fds f dsf sdfsdfsdf sdf sd fs dfds fsd f dsf ds fsd fs df sf",
        type: "commercial",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Annapoorna Hotel",
        image: [{
            itemImageSrc: projectBaseUrl + 'Commercial/FINAL IMAGE 2.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Commercial/FINAL IMAGE 2.jpg',
            alt: 'Modern Interior Design',
            title: 'Clasic Residence Design'
        },

        ],
        description: "test description fsdfsdf sdf dsf dsf sd fds f dsf sdfsdfsdf sdf sd fs dfds fsd f dsf ds fsd fs df sf",
        type: "commercial",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Hero Showroom",
        image: [{
            itemImageSrc: projectBaseUrl + 'Commercial/Hero Showroom Palay ch 3.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Commercial/Hero Showroom Palay ch 3.jpg',
            alt: 'Modern Interior Design',
            title: 'Clasic Residence Design'
        },{
            itemImageSrc: projectBaseUrl + 'Commercial/HERO SHOWROOM.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Commercial/HERO SHOWROOM.jpg',
            alt: 'Modern Interior Design',
            title: 'Clasic Residence Design'
        },

        ],
        description: "test description fsdfsdf sdf dsf dsf sd fds f dsf sdfsdfsdf sdf sd fs dfds fsd f dsf ds fsd fs df sf",
        type: "commercial",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "JK Complex",
        image: [{
            itemImageSrc: projectBaseUrl + 'Commercial/JK Complex ch.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Commercial/JK Complex ch.jpg',
            alt: 'Modern Interior Design',
            title: 'Clasic Residence Design'
        },

        ],
        description: "test description fsdfsdf sdf dsf dsf sd fds f dsf sdfsdfsdf sdf sd fs dfds fsd f dsf ds fsd fs df sf",
        type: "commercial",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Abc Residence",
        image: [{
            itemImageSrc: projectBaseUrl + 'Commercial/Junction Residence 2.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Commercial/Junction Residence 2.jpg',
            alt: 'Modern Interior Design',
            title: 'Clasic Residence Design'
        },{
            itemImageSrc: projectBaseUrl + 'Commercial/Junction Residence.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Commercial/Junction Residence.jpg',
            alt: 'Modern Interior Design',
            title: 'Clasic Residence Design'
        },

        ],
        description: "test description fsdfsdf sdf dsf dsf sd fds f dsf sdfsdfsdf sdf sd fs dfds fsd f dsf ds fsd fs df sf",
        type: "commercial",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "K V Madhu Bakery",
        image: [{
            itemImageSrc: projectBaseUrl + 'Commercial/K V Madhu Bakery day ch.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Commercial/K V Madhu Bakery day ch.jpg',
            alt: 'Modern Interior Design',
            title: 'Clasic Residence Design'
        },

        ],
        description: "test description fsdfsdf sdf dsf dsf sd fds f dsf sdfsdfsdf sdf sd fs dfds fsd f dsf ds fsd fs df sf",
        type: "commercial",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Mobile Shop",
        image: [{
            itemImageSrc: projectBaseUrl + 'Commercial/kaber bhai ch Fn.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Commercial/kaber bhai ch Fn.jpg',
            alt: 'Modern Interior Design',
            title: 'Clasic Residence Design'
        },

        ],
        description: "test description fsdfsdf sdf dsf dsf sd fds f dsf sdfsdfsdf sdf sd fs dfds fsd f dsf ds fsd fs df sf",
        type: "commercial",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Kurumbur Complex",
        image: [{
            itemImageSrc: projectBaseUrl + 'Commercial/Kurumbur Day Fn.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Commercial/Kurumbur Day Fn.jpg',
            alt: 'Modern Interior Design',
            title: 'Clasic Residence Design'
        },{
            itemImageSrc: projectBaseUrl + 'Commercial/Kurumbur Night Fn.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Commercial/Kurumbur Night Fn.jpg',
            alt: 'Modern Interior Design',
            title: 'Clasic Residence Design'
        },

        ],
        description: "test description fsdfsdf sdf dsf dsf sd fds f dsf sdfsdfsdf sdf sd fs dfds fsd f dsf ds fsd fs df sf",
        type: "commercial",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Madarassa Exterior",
        image: [{
            itemImageSrc: projectBaseUrl + 'Commercial/Madarassa Exterior.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Commercial/Madarassa Exterior.jpg',
            alt: 'Modern Interior Design',
            title: 'Clasic Residence Design'
        },

        ],
        description: "test description fsdfsdf sdf dsf dsf sd fds f dsf sdfsdfsdf sdf sd fs dfds fsd f dsf ds fsd fs df sf",
        type: "commercial",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Mansion Exterior",
        image: [{
            itemImageSrc: projectBaseUrl + 'Commercial/Mansion Exterior.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Commercial/Mansion Exterior.jpg',
            alt: 'Modern Interior Design',
            title: 'Clasic Residence Design'
        },

        ],
        description: "test description fsdfsdf sdf dsf dsf sd fds f dsf sdfsdfsdf sdf sd fs dfds fsd f dsf ds fsd fs df sf",
        type: "commercial",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "MRT Metals",
        image: [{
            itemImageSrc: projectBaseUrl + 'Commercial/MRT Metals Day view FINAL.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Commercial/MRT Metals Day view FINAL.jpg',
            alt: 'Modern Interior Design',
            title: 'Clasic Residence Design'
        },{
            itemImageSrc: projectBaseUrl + 'Commercial/MRT Metals night view opt 2.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Commercial/MRT Metals night view opt 2.jpg',
            alt: 'Modern Interior Design',
            title: 'Clasic Residence Design'
        },

        ],
        description: "test description fsdfsdf sdf dsf dsf sd fds f dsf sdfsdfsdf sdf sd fs dfds fsd f dsf ds fsd fs df sf",
        type: "commercial",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Nathan Furniture",
        image: [{
            itemImageSrc: projectBaseUrl + 'Commercial/Nathan furniture C1.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Commercial/Nathan furniture C1.jpg',
            alt: 'Modern Interior Design',
            title: 'Clasic Residence Design'
        },

        ],
        description: "test description fsdfsdf sdf dsf dsf sd fds f dsf sdfsdfsdf sdf sd fs dfds fsd f dsf ds fsd fs df sf",
        type: "commercial",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Commercial Complex",
        image: [{
            itemImageSrc: projectBaseUrl + 'Commercial/opt 5 Day.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Commercial/opt 5 Day.jpg',
            alt: 'Modern Interior Design',
            title: 'Clasic Residence Design'
        },{
            itemImageSrc: projectBaseUrl + 'Commercial/opt 5 Night.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Commercial/opt 5 Night.jpg',
            alt: 'Modern Interior Design',
            title: 'Clasic Residence Design'
        },

        ],
        description: "test description fsdfsdf sdf dsf dsf sd fds f dsf sdfsdfsdf sdf sd fs dfds fsd f dsf ds fsd fs df sf",
        type: "commercial",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Pallavaram elevation",
        image: [{
            itemImageSrc: projectBaseUrl + 'Commercial/Pallavaram elevation.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Commercial/Pallavaram elevation.jpg',
            alt: 'Modern Interior Design',
            title: 'Clasic Residence Design'
        },

        ],
        description: "test description fsdfsdf sdf dsf dsf sd fds f dsf sdfsdfsdf sdf sd fs dfds fsd f dsf ds fsd fs df sf",
        type: "commercial",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "Sangeetham Hotel",
        image: [{
            itemImageSrc: projectBaseUrl + 'Commercial/Sangeetham Hotel A2.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Commercial/Sangeetham Hotel A2.jpg',
            alt: 'Modern Interior Design',
            title: 'Clasic Residence Design'
        },{
            itemImageSrc: projectBaseUrl + 'Commercial/Sangeetham Hotel.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Commercial/Sangeetham Hotel.jpg',
            alt: 'Modern Interior Design',
            title: 'Clasic Residence Design'
        },

        ],
        description: "test description fsdfsdf sdf dsf dsf sd fds f dsf sdfsdfsdf sdf sd fs dfds fsd f dsf ds fsd fs df sf",
        type: "commercial",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    {
        name: "The Eye Foundation",
        image: [{
            itemImageSrc: projectBaseUrl + 'Commercial/The I foundation front.jpg',
            thumbnailImageSrc: projectBaseUrl + 'Commercial/The I foundation front.jpg',
            alt: 'Modern Interior Design',
            title: 'Clasic Residence Design'
        },

        ],
        description: "test description fsdfsdf sdf dsf dsf sd fds f dsf sdfsdfsdf sdf sd fs dfds fsd f dsf ds fsd fs df sf",
        type: "commercial",
        duration: "2",
        purpose: "residential",
        client: "Aleen nagar"
    },
    
]

export const projectTypes = ["architecture", "interior", "consultant","commercial"]

export const ourServicesData = {
    design: [
        {
            name: 'Concept Plan',
            subTitle: "Schematic Plan Includes",
            points: [
                "Overall floor plans",
                "Room dimensions"
            ],
            description: "(Not for construction)",
            images: [
                serviceBaseUrl+"End_to_end_design/Concept_plan/Faizal_plan.jpg", 
                serviceBaseUrl+"End_to_end_design/Concept_plan/Farooq_plan.jpg", 
                serviceBaseUrl+"End_to_end_design/Concept_plan/Hidayathulla_Plan.jpg", 
                serviceBaseUrl+"End_to_end_design/Concept_plan/Masjid_Floor_plan.jpg", 
                serviceBaseUrl+"End_to_end_design/Concept_plan/Resturant_plan.jpg"
            ]
        },
        {
            name: 'Working Drawing',
            subTitle: "Construction Drawings Includes",
            points: [
                "Dimension for wall construction",
                "Door and Window size"
            ],
            description: "(Good for construction)",
            images: [
                serviceBaseUrl+"End_to_end_design/Working_Drawing/Hidathulla_plan.jpg", 
                serviceBaseUrl+"End_to_end_design/Working_Drawing/Bedroom.jpg", 
                serviceBaseUrl+"End_to_end_design/Working_Drawing/Jabir_plan.jpg", 
                serviceBaseUrl+"End_to_end_design/Working_Drawing/Murugesh.jpg", 
                serviceBaseUrl+"End_to_end_design/Working_Drawing/Virudunagar.jpg"
            ]
        },
        {
            name: 'Staircase Drawing',
            subTitle: "Staircase Drawing Includes",
            points: [
                "Riser and Tread details",
                "Slope details for RCC as provoided in drawing"
            ],
            description: "(Reinforcement will based on structural design and Good for construction)",
            images: [
                serviceBaseUrl+"End_to_end_design/Staircase_Drawing/Hidayathulla_plan.jpg", 
                serviceBaseUrl+"End_to_end_design/Staircase_Drawing/Prabu_plan.jpg", 
                serviceBaseUrl+"End_to_end_design/Staircase_Drawing/Syed_plan.jpg", 
                serviceBaseUrl+"End_to_end_design/Staircase_Drawing/Ukkirankottai.jpg", 
                serviceBaseUrl+"End_to_end_design/Staircase_Drawing/Virudunagar.jpg"
            ]
        },
        {
            name: 'Electrical Drawing',
            subTitle: "Electrical Drawings Includes",
            points: [
                "Switch board location",
                "Electrical outlet location with dimension"
            ],
            description: "(Good for construction)",
            images: [
                 serviceBaseUrl+"End_to_end_design/Electrical_Drawing/Hidayathullah_plan.jpg", 
                 serviceBaseUrl+"End_to_end_design/Electrical_Drawing/Jabir_plan.jpg", 
                 serviceBaseUrl+"End_to_end_design/Electrical_Drawing/Madarassa_ELECTRICAL.jpg"]
        },
        {
            name: 'Structural Drawings',
            subTitle: "Structural Drawings Includes",
            points: [
                "Structural design is not our scope",
                "it will done by third party",
                "We coordinate with them to get required drawings as per our design",
                "Drawings includes Footing,Column, ground beam,roof beam & Roof slab"
            ],
            description: "",
            images: [
                serviceBaseUrl+"End_to_end_design/Structural_Drawing/FOOTING.jpg", 
                serviceBaseUrl+"End_to_end_design/Structural_Drawing/COLUMN.jpg", 
                serviceBaseUrl+"End_to_end_design/Structural_Drawing/GF Roof beam details.jpg", 
                serviceBaseUrl+"End_to_end_design/Structural_Drawing/GF Roof beam.jpg", 
                serviceBaseUrl+"End_to_end_design/Structural_Drawing/GF Roof slab.jpg"]
        },
        {
            name: 'Furniture Layout',
            subTitle: "Conceptual furniture layouts in every room space & Door window details.",
            points: [],
            description: "",
            images: [
                serviceBaseUrl+"End_to_end_design/Furniture_layout/Adikkalapattinam.jpg", 
                serviceBaseUrl+"End_to_end_design/Furniture_layout/PKR_14042018.jpg", 
                serviceBaseUrl+"End_to_end_design/Furniture_layout/Prabu_Residence.jpg"
            ]
        },
        {
            name: 'Presentation Plan',
            subTitle: "Presentaion Plan Includes",
            points: [
                "Interior furniture layout",
                "Grapical floor plan",
                "Floor finish texture"
            ],
            description: "",
            images: [
                serviceBaseUrl+"End_to_end_design/Presentation_plan/SF_Residence_Plan.jpg", 
                serviceBaseUrl+"End_to_end_design/Presentation_plan/First_floor_Render.jpg", 
                serviceBaseUrl+"End_to_end_design/Presentation_plan/Ground_floor_plan_FN.jpg", 
                serviceBaseUrl+"End_to_end_design/Presentation_plan/render_plan.jpg"
            ]
        },
        {
            name: 'Plan 3D View',
            subTitle: "Plan Isometric view for 3D visualization of interior furniture layouts and door window locarions in room.",
            points: [],
            description: "",
            images: [
                serviceBaseUrl+"End_to_end_design/Plan_3d_View/Final_plan_ch1.jpg", 
                serviceBaseUrl+"End_to_end_design/Plan_3d_View/GF_Top_view.jpg", 
                serviceBaseUrl+"End_to_end_design/Plan_3d_View/Top_View_Ch.jpg"
            ]
        },
        {
            name: 'Exterior Design',
            subTitle: "Exterior 3D model 1 option with 2 correction",
            points: [],
            description: "",
            images: [
                serviceBaseUrl+"End_to_end_design/Exterior_Design/deva_sir_work_4.jpg", 
                serviceBaseUrl+"End_to_end_design/Exterior_Design/Aqeel_Residence.jpg", 
                serviceBaseUrl+"End_to_end_design/Exterior_Design/Final_image_ch1.jpg", 
                serviceBaseUrl+"End_to_end_design/Exterior_Design/Final_img_1.jpg", 
                serviceBaseUrl+"End_to_end_design/Exterior_Design/Fn_edit.jpg", 
                serviceBaseUrl+"End_to_end_design/Exterior_Design/Kumar_Residence_opt 1.jpg", 
                serviceBaseUrl+"End_to_end_design/Exterior_Design/Residence_Exterior.jpg", 
                serviceBaseUrl+"End_to_end_design/Exterior_Design/Riyaz_final_opt_4.jpg", 
                serviceBaseUrl+"End_to_end_design/Exterior_Design/The_eye_foundation.jpg", 
                serviceBaseUrl+"End_to_end_design/Exterior_Design/final_edit_image.jpg"
            ]
        },
        {
            name: 'Exterior Drawing',
            subTitle: "Exterior Dimention with meterial specification",
            points: [],
            description: "(Good for construction)",
            images: [
                serviceBaseUrl+"End_to_end_design/Exterior_Drawing/Hidathullah.jpg", 
                serviceBaseUrl+"End_to_end_design/Exterior_Drawing/Araikkulam.jpg", 
                serviceBaseUrl+"End_to_end_design/Exterior_Drawing/Siraj.jpg", 
                serviceBaseUrl+"End_to_end_design/Exterior_Drawing/Virudunagar.jpg"]
        },
        {
            name: 'Interior 3D Views',
            subTitle: "Interior 3D views for room with 2 angle with 2 correction",
            points: [],
            description: "",
            images: [
                serviceBaseUrl+"End_to_end_design/Interior_design/AP Living Room Angle 1.jpg",
                serviceBaseUrl+"End_to_end_design/Interior_design/Aleem_Nage_Living_2.jpg", 
                serviceBaseUrl+"End_to_end_design/Interior_design/Bakery Interior.jpg", 
                serviceBaseUrl+"End_to_end_design/Interior_design/Clinic design interior view.jpg", 
                serviceBaseUrl+"End_to_end_design/Interior_design/Dinesh interior copy.jpg", 
                serviceBaseUrl+"End_to_end_design/Interior_design/Junaid ff hall 2.jpg", 
                serviceBaseUrl+"End_to_end_design/Interior_design/Junaid hall 1.jpg", 
                serviceBaseUrl+"End_to_end_design/Interior_design/Pettai Kitchen.jpg", 
                serviceBaseUrl+"End_to_end_design/Interior_design/Pettai br 2.jpg", 
                serviceBaseUrl+"End_to_end_design/Interior_design/Riyaz Living 1.jpg", 
                serviceBaseUrl+"End_to_end_design/Interior_design/Syed Kitchen.jpg"
            ]
        },
        {
            name: 'Interior Drawing',
            subTitle: "Interior Drawings Includes",
            points: [
                "Wood work details",
                "False ceiling details",
                "Material Specificaion",
                "Section details"
            ],
            description: "",
            images: [
                serviceBaseUrl+"End_to_end_design/Interior_Drawing/Jahangir.jpg",
                serviceBaseUrl+"End_to_end_design/Interior_Drawing/DRESSING_UNIT_1.jpg",
                serviceBaseUrl+"End_to_end_design/Interior_Drawing/DRESSING_UNIT_2.jpg", 
                serviceBaseUrl+"End_to_end_design/Interior_Drawing/GYPSUM_DETAILS.jpg", 
                serviceBaseUrl+"End_to_end_design/Interior_Drawing/Prabu_Residence_RCP.jpg", 
            ]
        },
        {
            name: '360 Interior',
            subTitle: "360 Interior Includes",
            points: [
                "Interior design in 360 view",
                "Explore our design in reality",
                "For better experience visit our office"
            ],
            description: "",
            images: [
                serviceBaseUrl+"End_to_end_design/360_Interior/360_fn.jpg", 
                serviceBaseUrl+"End_to_end_design/360_Interior/360bfinal.jpg", 
                serviceBaseUrl+"End_to_end_design/360_Interior/living_360_ch.jpg"
            ]
        },

    ],
    execution: [

        {
            name: 'Interior Execution',
            subTitle: "Interior Execution Includes",
            points: [
                "Planning & Design",
                "Material Selection",
                "Structural Coordination",
                "Project Scheduling",
                "Vendor & Contractor Management",
                "Quality Control",
                "Budget Management ",
                "Customization & Detailing",
                "Sustainability & Efficiency",
                "Final Handover & Snag Fixing",
            ],
            description: "",
            images: [
                serviceBaseUrl+"Interior_execution/IMG20211027141657.jpg", 
                serviceBaseUrl+"Interior_execution/IMG20201109141353.jpg", 
                serviceBaseUrl+"Interior_execution/IMG20211001095451.jpg", 
                serviceBaseUrl+"Interior_execution/IMG20211001095618.jpg", 
                serviceBaseUrl+"Interior_execution/IMG20211027141749.jpg", 
                serviceBaseUrl+"Interior_execution/IMG20231211105604.jpg", 
                serviceBaseUrl+"Interior_execution/Pettai interior study table .jpg"
            ]
        },
    ],
    consultant: [

        // {
        //     name:'Site Visit',
        //     subTitle:"Site visit Stages",
        //     points:[
        //         "Marking",
        //         "Before ground beam",
        //         "Before plinth beam",
        //         "Before lintel beam",
        //         "Before roof",
        //         "Before plastering",
        //         "Before flooring",
        //         "Before elevation"
        //     ],
        //     description:"",
        //     images:[consultImg1,consultImg2,consultImg3,consultImg4,consultImg5,consultImg6]
        // },
        {
            name: 'Construction',
            subTitle: "Overall construction progress will be managed us from marking to completion. Site visit Stages is given below",
            points: [
                "Marking",
                "Before ground beam",
                "Before plinth beam",
                "Before lintel beam",
                "Before roof",
                "Before plastering",
                "Before flooring",
                "Before elevation"
            ],
            description: "",
            images: [
                serviceBaseUrl+"Turnkey/Construction/Jabir_residence_copy.jpg", 
                serviceBaseUrl+"Turnkey/Construction/Aleem_nagar_edit_copy.jpg", 
                serviceBaseUrl+"Turnkey/Construction/IMG20200708173312.jpg", 
                serviceBaseUrl+"Turnkey/Construction/Kaja_mama residence.jpg", 
                serviceBaseUrl+"Turnkey/Construction/Karungulam_Residence.jpg", 
                serviceBaseUrl+"Turnkey/Construction/P_A_Rasool_Elevation 1x1.jpg", 
                serviceBaseUrl+"Turnkey/Construction/Siraj_residence_copy.jpg"
            ]
        },
        {
            name: 'Interior',
            subTitle: "For interior works we provoide end to end consultant service which helps to complete work on required quality check and completion as per given design",
            points: [],
            description: "",
            images: [
                serviceBaseUrl+"Turnkey/Interior/Beauty parlour poster.jpg", 
                serviceBaseUrl+"Turnkey/Interior/Bed room copy.jpg", 
                serviceBaseUrl+"Turnkey/Interior/Ceiling img 1.jpg", 
                serviceBaseUrl+"Turnkey/Interior/Dental Interior post.jpg", 
                serviceBaseUrl+"Turnkey/Interior/Dental exterior POST.jpg", 
                serviceBaseUrl+"Turnkey/Interior/Exterior  poster image.jpg", 
                serviceBaseUrl+"Turnkey/Interior/Pettai interior study table .jpg", 
                serviceBaseUrl+"Turnkey/Interior/Interior  poster image.jpg"
            ]
        },
    ]

}